const pendingJobs: Array<[string, Promise<unknown>]> = []

export const registerPrelaunchJob = (id: string, promise: Promise<unknown>) => {
  pendingJobs.push([id, promise])
}

/**
 * Call this function before calling `ReactDOM.render` to initialize
 * asynchronous parts of the app before it is rendered. By initializing these
 * before rendering the app, the app can skip loaders. This is important when
 * starting the app from a prerendered page.
 *
 * Without this solution the user would see a usable page, and, when the app
 * gets loaded, content would be replaced with a loader until the promises
 * resolves and the content is rendered again.
 *
 * Example usage:
 *
 * ```ts
 * waitForPrelaunchJobs().then(() => {
 *   ReactDOM.render(<App />, document.getElementById('root'))
 * })
 * ```
 */
export const waitForPrelaunchJobs = async () => {
  while (pendingJobs.length > 0) {
    // New jobs may be added while waiting

    if (process.env.REACT_APP_DEBUG_PRERENDERING) {
      console.log(
        'PRELAUNCH_JOBS',
        'Waiting for',
        pendingJobs.map(([id]) => id),
      )
    }

    // Remove pending jobs when they finish
    pendingJobs.forEach((item) => {
      const [, promise] = item
      promise.then(() => {
        pendingJobs.splice(pendingJobs.indexOf(item), 1)
      })
    })

    // Wait for all pending jobs asynchronously
    await Promise.all(pendingJobs.map(([, promise]) => promise))
  }

  if (process.env.REACT_APP_DEBUG_PRERENDERING) {
    console.log('PRELAUNCH_JOBS', 'Finished')
  }
}
